export enum ControlBarAction {
  ApplyProperty = `applyProperty`,
  RemoveProperty = `removeProperty`,
  Filter = `filter`,
  Rename = `rename`,
  Duplicate = `duplicate`,
  Delete = `delete`,
}

export const ControlBarActionItems = {
  [ControlBarAction.Filter]: {
    value: ControlBarAction.Filter,
    label: `Add filter...`,
    shortLabel: `Filter`,
    icon: `filter`,
    wrapSubLabel: true,
  },
  [ControlBarAction.ApplyProperty]: {
    value: ControlBarAction.ApplyProperty,
    label: `Add aggregation…`,
    shortLabel: `Aggregate`,
    icon: `type-number`,
    wrapSubLabel: true,
  },
  [ControlBarAction.RemoveProperty]: {
    value: ControlBarAction.RemoveProperty,
    label: `Remove aggregation`,
    shortLabel: `Aggregate`,
    icon: `type-number`,
    wrapSubLabel: true,
  },
  [ControlBarAction.Rename]: {
    value: ControlBarAction.Rename,
    icon: `edit`,
    label: `Rename`,
  },
  [ControlBarAction.Duplicate]: {
    value: ControlBarAction.Duplicate,
    icon: `duplicate`,
    label: `Duplicate`,
  },
  [ControlBarAction.Delete]: {
    value: ControlBarAction.Delete,
    icon: `trashcan`,
    label: `Delete`,
  },
};
